import {Component} from '@angular/core';
import {DialogService, PesAlertDialogComponent} from '@pes/ui';

@Component({
    selector: 'qr-code-dialog',
    templateUrl: 'qr-code-dialog.component.html'
})
export class QRCodeDialogComponent extends PesAlertDialogComponent {

    constructor(dialogService: DialogService) {
        super(dialogService);
    }
}



// WEBPACK FOOTER //
// ./src/app/component/qr-code/qr-code-dialog.component.ts